import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TemplatesService {
deleteFailed = 'data delete failed' ; deleteSuccess = 'data delete success' ; insertFailed = 'data insert failed' ; dataFails = 'data fails' ; dataSuccess = 'data success'
	contentType = 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15'; dataInsertedSuccess = 'data inserted success'
	hdr = new HttpHeaders().set('Content-Type', 'application/json');
	
	constructor(private readonly http : HttpClient) { }

	//get template details

	getTemplateDetails(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/templates`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	//get task details

	getDetails(templateID): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/templates/task/${templateID}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	//add , delete template

	addTemplate(arrData: any): Observable<any> {
		const headers = this.hdr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/templates/addTemplate`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	deleteTemplate(arrData: any): Observable<any> {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/templates/deleteTemplate/${arrData.templateID}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	downloadTemplate(templateId): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': this.contentType,
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/downloadTemplate/${templateId}`, httpCustomOptions)
			.pipe(
				tap(_ => this.log(this.dataSuccess)),
				catchError(this.handleError<any>(this.dataFails))
			);
	}

	//add,edit,delete tasks

	addTask(arrData: any): Observable<any> {
		const headers = this.hdr
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/templates/addTask`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	editTask(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/templates/updateTask`, arrData)
			.pipe(
				tap(_ => this.log(this.dataInsertedSuccess)),
				catchError(this.handleError<any>(this.insertFailed))
			);
	}

	deleteTask(arrData: any): Observable<any> {
		return this.http
			.delete(`${environment.baseAPIURL}/api/v1/templates/deleteTask/${arrData.templatetaskID}`)
			.pipe(
				tap(_ => this.log(this.deleteSuccess)),
				catchError(this.handleError<any>(this.deleteFailed))
			);
	}

	uploadTemplate(file: File, templateID): Observable<any> {
		const fd: FormData = new FormData();
		fd.append('file', file, file.name);
		return this.http.post(`${environment.baseAPIURL}/api/v1/validateTemplate/${templateID}`, fd)
			.pipe(
				tap(_ => this.log('template file upload success')),
				catchError(this.handleError<any>('template file upload failed'))
			);
	}

	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}




}



